var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSammelnHeaderMenuMini({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71986 2.24663V5.61658H2.42445V2.24663H5.71986ZM0.227504 0V7.86322H7.91682V0H0.227504ZM11.2122 0H20V2.24663H11.2122V0ZM11.2122 7.86322H20V10.1098H11.2122V7.86322ZM11.2122 15.7264H20V17.9731H11.2122V15.7264ZM8.69355 13.7124L7.14006 12.1238L3.52292 15.8228L1.55347 13.8088L0 15.3974L3.52292 19L8.69355 13.7124Z",
    fill: "#2C4D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSammelnHeaderMenuMini);
export default __webpack_public_path__ + "static/media/sammeln_header_menu_mini.e2a6111becc2d9e43b274f8f502152f9.svg";
export { ForwardRef as ReactComponent };